import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ɵlooseIdentical
} from '@angular/core';
import * as MediumEditor from 'medium-editor';
import { Event } from '@angular/router/src/events';

/**
 * Medium Editor wrapper directive.
 *
 * Examples
 * <medium-editor
 *    [(editorModel)]="textVar"
 *    [editorOptions]="{'toolbar': {'buttons': ['bold', 'italic', 'underline', 'h1', 'h2', 'h3']}}"
 *    [editorPlaceholder]="placeholderVar">
 * </medium-editor>
 */
@Directive({
  selector: '[appCustomMediumEditor]'
})
export class CustomMediumEditorDirective implements OnInit, OnChanges, OnDestroy {

  @Input('editorModel') editorModel: any;
  @Input('editorOptions') editorOptions: any;
  @Input('editorPlaceholder') editorPlaceholder: string;

  @Output('editorModelChange') editorModelChange = new EventEmitter();
  @Output('editorBlur') editorBlur = new EventEmitter();

  private lastViewModel: string;
  private element: HTMLElement;
  private editor: any;
  private active: boolean;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.element = this.el.nativeElement;
    this.element.innerHTML = '<div class="me-editable">' + this.editorModel + '</div>';
    this.active = true;

    if (this.editorPlaceholder && this.editorPlaceholder.length) {
      this.editorOptions.placeholder = {
        text: this.editorPlaceholder
      };
    }

    // Global MediumEditor
    this.editor = new MediumEditor('.me-editable', this.editorOptions);
    this.editor.subscribe('editableInput', () => {
      this.updateModel();
    });

    this.editor.subscribe('blur', (event) => {
      this.onBlur(event);
    });
  }

  refreshView() {
    if (this.editor) {
      this.editor.setContent(this.editorModel);
    }
  }

  ngOnChanges(changes: any): void {
    if (this.isPropertyUpdated(changes, this.lastViewModel)) {
      this.lastViewModel = this.editorModel;
      this.refreshView();
    }
  }

  /**
   * Emit updated model
   */
  updateModel(): void {
    let value = this.editor.getContent();
    value = value.replace(/&nbsp;/g, '')
      .replace(/<p><br><\/p>/g, '')
      .trim();
    this.lastViewModel = value;
    this.editorModelChange.emit(value);
  }

  /**
   * Remove MediumEditor on destruction of directive
   */
  ngOnDestroy(): void {
    this.editor.destroy();
  }

  isPropertyUpdated(changes: any, viewModel: any) {
    if (!changes.hasOwnProperty('model')) { return false; }

    const change = changes.model;

    if (change.isFirstChange()) {
      return true;
    }
    return !ɵlooseIdentical(viewModel, change.currentValue);
  }

  onBlur($event: Event): void {
    this.editorBlur.emit($event);
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/directives/customMediumEditor.directive.ts